module.exports = __webpack_public_path__ + "static/img/fg1.34b4da9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/fg1.png
// module id = 68oq
// module chunks = 0